import React, { Component } from 'react';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import {
  Compass,
  Desert,
  NoConnection
} from '../../../ecs/components/images/illustrations/no-data';

import './ExperimentBlockError.scss';

class ExperimentBlockError extends Component {
  illustrationFor(error) {
    switch (error) {
      case 'noexperiments':
        return <Compass />;
      case 'session':
        return <NoConnection />;
      default:
        return <Desert />;
    }
  }
  render() {
    const { error } = this.props;
    return (
      <div>
        <div className="illustration-container">
          {this.illustrationFor(error)}
        </div>
        <div className="error-container with-heading">
          <h2>
            <FormattedMessage id={`components.ecs.${error}.header`} />
          </h2>
          <FormattedMessage id={`components.ecs.${error}.description`} />
        </div>
      </div>
    );
  }
}

ExperimentBlockError.propTypes = {
  error: PropTypes.string.isRequired,
  intl: intlShape.isRequired
};

export default injectIntl(ExperimentBlockError);
